import { useEffect, useState } from "react";
import { API } from "@/lib/api";

/**
 * Load a proof image as a blob URL. Returns null while loading or if
 * no proof is present. Revokes the object URL on cleanup.
 */
export default function useProofImage(planId, actionIndex, hasProof, uploadedAt) {
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    let cancelled = false;
    let objectUrl;
    if (!hasProof) {
      setPreview(null);
      return () => {};
    }
    const url = `${API}/plans/${planId}/actions/${actionIndex}/proof?t=${uploadedAt || ""}`;
    fetch(url)
      .then(async (r) => {
        if (!r.ok || cancelled) return;
        const blob = await r.blob();
        objectUrl = URL.createObjectURL(blob);
        if (!cancelled) setPreview(objectUrl);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [hasProof, planId, actionIndex, uploadedAt]);

  return preview;
}
